import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme, ThemeOptions, ThemeProvider } from '@material-ui/core';
import MUIRichTextEditor, { TCustomControl } from 'mui-rte';

import React from 'react';

import { baseTheme } from '../../../../theme';

interface IRichTextTheme {
  pixelHeight: number;
}

interface IPostEditorProps {
  handleChanges?: (state: any) => void;
  onBlur?: () => void;
  pixelHeight?: number;
  customControls?: TCustomControl[];
  editorControls?: string[];
  data?: any;
  defaultValue?: string;
  label?: string;
  typeResolver?: string | undefined;
}

const useStyles = (
  props: IRichTextTheme,
  typeResolver: string | undefined) =>
  makeStyles((theme: Theme) =>
    createStyles({
      root: {
        paddingRight: theme.spacing(0),
        paddingBottom: theme.spacing(0),
        paddingLeft: theme.spacing(0),
        paddingTop: theme.spacing(0),
        minHeight: `${props.pixelHeight} px`,
        maxHeight: `${props.pixelHeight} px`,
        '& .MuiIconButton-root': {
          color: toolBarColorPicker(typeResolver),
        },
      },
    }),
  );

const toolBarColorPicker = (typeResolver: string | undefined) => {
  return typeResolver === 'Public'
    ? 'rgba(65, 0, 153, 1.0)'
    : typeResolver === 'Private'
      ? 'rgba(0, 101, 207, 1.0)'
      : 'rgba(0, 0, 0, 1.0)';
};

const enhanceTheme = (theme: ThemeOptions) =>
  Object.assign(theme, {
    ...theme.overrides,
    overrides: {
      MUIRichTextEditor: {
        root: {
          height: '400px',
        },
        container: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        },
        editor: {
          border: 'solid 1px #ebebeb',
          padding: '10px',
          overflow: 'auto',
          height: '93%',
        },
        placeHolder: {
          position: 'absolute',
          top: '40px',
          padding: '10px',
          width: '100%',
        },
        anchorLink: {
          color: '#333333',
          textDecoration: 'underline',
        },
      },
    },
  });

export default function PostEditor(props: IPostEditorProps) {
  const { typeResolver } = props;
  const defaultEditorControls = [
    // Standard Controls
    'title',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'clear',
    'highlight',
    // 'link',
    // 'media',
    'numberList',
    'bulletList',
    'quote',
    // 'code',
    // 'save',
    'undo',
    'redo',
  ];
  const {
    pixelHeight = 200,
    customControls = [],
    editorControls = defaultEditorControls,
    data = null,
    defaultValue = '',
    label = '',
    handleChanges = (state: any) => {
      console.log('you are not handling the changes for the Rich Text Editor in use. Please provide a handleChanges method.');
    },
    onBlur = () => {
      console.log('you are not handling the save event for the Rich Text Editor.');
    },
  } = props;

  const classes = useStyles({ pixelHeight }, typeResolver)(enhanceTheme(baseTheme));

  const getCustomControlNames = (items: object[]) => items.map((item: any) => item.name);

  return (
    <Grid item className={classes.root}>
      <MUIRichTextEditor
        onChange={handleChanges}
        onBlur={onBlur}
        controls={[
          ...editorControls,
          ...getCustomControlNames(customControls),
        ]}
        customControls={customControls}
        defaultValue={data || defaultValue}
        label={label}
      />
    </Grid>
  );
}
